import React from 'react';
import {Stack} from '@mui/material';
import {useFormContext} from 'react-hook-form';

import {MaskedInput} from 'presentation/components';
import {OperationStateTypesEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import {masks} from 'presentation/utils';
import {AddressDataFormValues} from '../../../AddressForm/validation';
import {AddressSearchTypeProps} from './types';

const {address: addressLabel} = translations['pt-br'].privateFlow.profile.changeData;

export function AddressSearchType({
	operationState,
	onZipCodeChange,
	onZipCodeFocus,
}: AddressSearchTypeProps) {
	const {
		register,
		formState: {errors},
	} = useFormContext<AddressDataFormValues>();

	return (
		<Stack gap={2}>
			<MaskedInput
				{...register('zipCode')}
				id="zipCode"
				inputMode="numeric"
				label={addressLabel.zipCode}
				placeholder={addressLabel.zipCode}
				error={!!errors.zipCode}
				helperText={
					errors.zipCode?.message ? errors.zipCode.message : addressLabel.zipCodeInfo
				}
				slotProps={{formHelperText: {sx: {fontSize: '0.75rem'}}}}
				maskOptions={masks.zipCode}
				$fieldName="zipCode"
				onChange={e => onZipCodeChange(e.target.value)}
				onFocus={onZipCodeFocus}
				endAdornmentVariant={
					operationState === OperationStateTypesEnum.PENDING ? 'loading' : 'tooltip'
				}
				tooltipText={addressLabel.tooltip}
			/>
		</Stack>
	);
}
